import React from 'react';
import PropTypes from 'prop-types';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';

function MonthBarChart({ data, graphWidth }) {
  return (
    <BarChart
      width={graphWidth}
      height={300}
      data={data}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5,
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="date" />
      <XAxis
        dataKey="date"
        axisLine={false}
        tickLine={false}
        interval={0}
        tick={null}
        height={1}
        scale="band"
        xAxisId="quarter"
      />
      <YAxis />
      <Tooltip />
      <Legend />
      <Bar dataKey="essay" fill="#82ca9d" />
      <Bar dataKey="story" fill="#8884d8" />
    </BarChart>
  );
}

MonthBarChart.propTypes = {
  data: PropTypes.arrayOf(Object),
  graphWidth: PropTypes.number.isRequired,
};

export default MonthBarChart;
